<template>
  <NetworkDetails />
</template>

<script>
import NetworkDetails from '../../../components/crypto/NetworkDetails.vue'
export default {
  components: {
    NetworkDetails,
  },
}
</script>

<style scoped lang="scss"></style>
